
import { BasePage } from "./BasePage";

import type { PageTemplateProps } from "./types";

// Your Opportunity — the live-data centerpiece of the room. Typically holds
// OpportunitySnapshot, SuppressionDiagnoses, ChannelCoverage, plus a Loom
// walkthrough and a what-we-heard RichText.
export function YourOpportunity(props: PageTemplateProps) {
    return <BasePage {...props} />;
}
